import { useParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Smartphone, Download } from "lucide-react";

const SharePage = () => {
  const { shareId } = useParams<{ shareId: string }>();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-background to-secondary/20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md mx-auto text-center">
        {/* Logo/Brand */}
        <div className="mb-8">
          <div className="h-16 w-16 rounded-xl bg-primary/10 flex items-center justify-center mx-auto mb-4">
            <Smartphone className="h-8 w-8 text-primary" />
          </div>
          <h1 className="text-2xl font-bold text-foreground">
            <span className="text-primary">Zuto</span>
          </h1>
          <p className="text-sm text-muted-foreground mt-2">
            Your Smart Lecture Companion
          </p>
        </div>

        {/* Main Message */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold text-foreground mb-4">
            Download Zuto - your smart lecture companion to view the notes
          </h2>
          <p className="text-muted-foreground">
            To access the shared notes, you need to download the Zuto app on your mobile device.
          </p>
        </div>

        {/* Download Buttons */}
        <div className="space-y-4">
          <a 
            href="https://apps.apple.com/us/app/zuto-ai-assistant/id6752733945" 
            target="_blank" 
            rel="noopener noreferrer"
            className="block"
          >
            <Button 
              className="w-full bg-primary hover:bg-primary/90 text-primary-foreground flex items-center justify-center gap-3 py-6"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                <path d="M11.6734 1.22197C11.8001 1.09185 12 1.17358 12 1.35299V12H13V1.35299C13 1.17358 13.1999 1.09185 13.3266 1.22197C14.2343 2.12436 16.4279 4.67453 16.9466 8H17.9747C17.9915 8 18 8.00848 18 8.02533V8.97467C18 8.99152 17.9915 9 17.9747 9H16.9743C16.9584 9 16.9487 9.01386 16.9535 9.02918C16.9771 9.09434 17 9.16135 17 9.23077V11.7692C17 11.8386 16.9771 11.9057 16.9535 11.9708C16.9487 11.9861 16.9584 12 16.9743 12H17.9747C17.9915 12 18 12.0085 18 12.0253V12.9747C18 12.9915 17.9915 13 17.9747 13H16.9743C16.9584 13 16.9487 13.0139 16.9535 13.0292C16.9771 13.0943 17 13.1614 17 13.2308V15.7692C17 15.8386 16.9771 15.9057 16.9535 15.9708C16.9487 15.9861 16.9584 16 16.9743 16H17.9747C17.9915 16 18 16.0085 18 16.0253V16.9747C18 16.9915 17.9915 17 17.9747 17H16.9466C16.4279 20.3255 14.2343 22.8756 13.3266 23.778C13.1999 23.9082 13 23.8264 13 23.647V13H12V23.647C12 23.8264 11.8001 23.9082 11.6734 23.778C10.7657 22.8756 8.57214 20.3255 8.05345 17H7.02533C7.00848 17 7 16.9915 7 16.9747V16.0253C7 16.0085 7.00848 16 7.02533 16H8.02566C8.04158 16 8.05132 15.9861 8.04654 15.9708C8.02286 15.9057 8 15.8386 8 15.7692V13.2308C8 13.1614 8.02286 13.0943 8.04654 13.0292C8.05132 13.0139 8.04158 13 8.02566 13H7.02533C7.00848 13 7 12.9915 7 12.9747V12.0253C7 12.0085 7.00848 12 7.02533 12H8.02566C8.04158 12 8.05132 11.9861 8.04654 11.9708C8.02286 11.9057 8 11.8386 8 11.7692V9.23077C8 9.16135 8.02286 9.09434 8.04654 9.02918C8.05132 9.01386 8.04158 9 8.02566 9H7.02533C7.00848 9 7 8.99152 7 8.97467V8.02533C7 8.00848 7.00848 8 7.02533 8H8.05345C8.57214 4.67453 10.7657 2.12436 11.6734 1.22197Z" />
              </svg>
              <div className="text-left">
                <div className="text-sm font-medium">Download for</div>
                <div className="text-lg font-bold">iOS</div>
              </div>
            </Button>
          </a>
          
          <a 
            href="https://play.google.com/store/apps/details?id=ai.zuto.app" 
            target="_blank" 
            rel="noopener noreferrer"
            className="block"
          >
            <Button 
              className="w-full bg-primary hover:bg-primary/90 text-primary-foreground flex items-center justify-center gap-3 py-6"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                <path d="M3.609 1.814L13.792 12L3.61 22.186a.996.996 0 01-.61-.92V2.734a1 1 0 01.609-.92zm10.896 8.728l2.862-2.862 3.587 2.024c.777.438.777 1.577 0 2.014l-3.587 2.024-2.862-2.862L7.955 12l6.55-1.458z" />
              </svg>
              <div className="text-left">
                <div className="text-sm font-medium">Download for</div>
                <div className="text-lg font-bold">Android</div>
              </div>
            </Button>
          </a>
        </div>

        {/* Share ID Display (for reference) */}
        {shareId && (
          <div className="mt-8 p-4 bg-muted/50 rounded-lg">
            <p className="text-xs text-muted-foreground">
              Share ID: <span className="font-mono">{shareId}</span>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SharePage; 